<template>
  <div>
    <el-form
      size="small"
      :model="form"
      :label-position="labelPosition"
      :label-width="labelWidth"
      @submit.native.prevent
    >
      <el-form-item>
        <el-button type="primary" @click="parseJson">格式化</el-button>
      </el-form-item>
      <el-form-item>
        <el-input 
          type="textarea" 
          placeholder="json字符串" 
          :autosize="autosize"
          v-model="form.str">
        </el-input>
      </el-form-item>
      <el-form-item>
        <json-viewer
          :value="form.json"
          :expand-depth="5"
          copyable
          boxed>
        </json-viewer>
          <!-- <template slot="copy" slot-scope="scope">
            <el-button v-if="!scope.copied" type="text">copy</el-button>
            <el-button v-else type="text" disabled>copied</el-button>
          </template> -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import JsonViewer from "vue-json-viewer";
import { Message } from 'element-ui';
export default {
  components: {
    JsonViewer
  },
  name: "Json",
  data() {
    return {
      form: this.initform
    };
  },
  props: {
    labelPosition: {
      type: String,
      default: "left"
    },
    labelWidth: {
      type: String,
      default: "auto"
    },
    autosize: {
      type: Object,
      // ({ minRows: 5, maxRows: 35 }) equal {return { minRows: 5, maxRows: 35 }}      
      default: () => ({ minRows: 3, maxRows: 3 })
    },
    initform: {
      type: Object,
      default: () => ({
        str: "",
        json: {}
      })
    }
  },
  methods: {
    parseJson: function() {
      try {
        this.form.json = JSON.parse(this.form.str);
      } catch (error) {
        console.log(error);
        Message.error("不是合法的JSON");
      }
    }
  }
};
</script>

